import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as cardlessWithdrawApi from '@/network/api/cardlesswithdrawal.api.js'

/** requests Cards List
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
    const res = await cardsApi.cards(payload)

    if (res) context.commit('SAVE_CARDS', res.data.data)
    return res
}

/** Get Cardless withdraw list
@return {promise} - Get Cardless withdraw list
*/
export const requestCardlessWidthdrawList = async (context, payload) => {
    const res = await cardlessWithdrawApi.requestCardlessWidthdrawList(payload)

    if (res) context.commit('SAVE_CARDLESS_WITHDRAW_LIST', res.data.data)
}

/** Get Cardless withdraw Code Detail
@return {promise} - Get Cardless withdraw Code Detail
*/
export const requestCardlessWidthdrawCodeDetail = async (context, payload) => {
    const res = await cardlessWithdrawApi.requestCardlessWidthdrawCodeDetail(payload)

    if (res) context.commit('SAVE_CODE_DETAIL', res.data.data)
}

/** Cancel Cardless Withdraw Code
@return {promise} - Cancel Cardless Withdraw Code
*/
export const cancelCardlessWithdrawCode = async (context, payload) => {
    const res = await cardlessWithdrawApi.cancelCardlessWithdrawCode(payload)

    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
